import React from 'react';
import { useAppContext } from '../../contexts/MarketPerformanceContext';
import LastUpdatedIndicator from './LastUpdatedIndicator';
import { VoidState } from '../../utilities/VoidState';
import InstrumentDetailsTable from './Instruments/InstrumentDetailsTable';

const InstrumentDetails = () => {
    const { state: { marketIndex } } = useAppContext();

    return (
        <div className="instrument-table">
            <div className="instrument-performance-container fb-pb-7">
                {(!marketIndex.asAt || !marketIndex.asAt.length) ? (
                    <VoidState message={'Last updated date not available'}/>
                ) : (
                    <LastUpdatedIndicator/>
                )}
            </div>
            {(!marketIndex.instruments || marketIndex.instruments.length === 0) ? (
                <VoidState message={'Instrument details not available'}/>
            ) : (
                <InstrumentDetailsTable instruments={marketIndex.instruments}/>
            )}
        </div>
    );
};

export default InstrumentDetails;
